<main class="contact-page">
    <section class="contact-page__hero" aria-hidden="true">
        <img
            class="contact-page__hero-image"
            src="/assets/images/pages/contact-us.jpg"
            alt="">
    </section>

    <section class="contact-page__content">
        <header class="contact-page__header">
            <h1 class="contact-page__title">Send us a message</h1>
            <p class="contact-page__intro">
                Questions about buying, selling, or leasing? Reach out and a Gabali Realty agent will get back to you.
            </p>
        </header>

        <form
            class="contact-page__form"
            [formGroup]="contactForm"
            (ngSubmit)="submitForm(contactForm, formDirective)"
            #formDirective="ngForm">
            <div class="contact-page__grid">
                <div class="contact-page__column">
                    <mat-form-field appearance="outline" class="contact-page__field">
                        <mat-label>First name</mat-label>
                        <input matInput formControlName="firstName" autocomplete="given-name">
                        <mat-error *ngIf="contactForm.controls['firstName'].hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="contact-page__field">
                        <mat-label>Last name</mat-label>
                        <input matInput formControlName="lastName" autocomplete="family-name">
                        <mat-error *ngIf="contactForm.controls['lastName'].hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="contact-page__field">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" autocomplete="email">
                        <mat-error *ngIf="contactForm.controls['email'].hasError('required')">Required</mat-error>
                        <mat-error *ngIf="contactForm.controls['email'].hasError('email')">Enter a valid email</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="contact-page__field">
                        <mat-label>Phone</mat-label>
                        <input matInput type="tel" formControlName="phone" autocomplete="tel">
                        <mat-error *ngIf="contactForm.controls['phone'].hasError('required')">Required</mat-error>
                        <mat-error *ngIf="contactForm.controls['phone'].hasError('pattern')">
                            Enter a valid phone number
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="contact-page__column">
                    <mat-form-field appearance="outline" class="contact-page__field">
                        <mat-label>Reason for contact</mat-label>
                        <mat-select formControlName="reason">
                            <mat-option value="Buy">Buying or leasing a property</mat-option>
                            <mat-option value="Sell">Selling or leasing my property</mat-option>
                            <mat-option value="Query">Other questions about the market</mat-option>
                        </mat-select>
                        <mat-error *ngIf="contactForm.controls['reason'].hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="contact-page__field contact-page__field--message">
                        <mat-label>Message</mat-label>
                        <textarea
                            matInput
                            formControlName="message"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="8"
                            cdkAutosizeMaxRows="12"></textarea>
                        <mat-error *ngIf="contactForm.controls['message'].hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="contact-page__actions">
                <button
                    type="submit"
                    class="contact-page__submit"
                    [disabled]="!contactForm.valid || isSubmitting">
                    Send message
                </button>
                <p class="contact-page__error" *ngIf="failedSubmit">
                    Failed to submit your message. Please try again later.
                </p>
            </div>
        </form>
    </section>
</main>
